import { render, staticRenderFns } from "./specialdet.vue?vue&type=template&id=4fec5e56&scoped=true&"
import script from "./specialdet.vue?vue&type=script&lang=js&"
export * from "./specialdet.vue?vue&type=script&lang=js&"
import style0 from "./specialdet.vue?vue&type=style&index=0&id=4fec5e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec5e56",
  null
  
)

export default component.exports